<template>
  <div class="designfiletype-list">

    <v-container grid-list-xl fluid>
      <v-sheet
        min-height="300"
        rounded="lg"
        elevation="6"
      >

      <v-toolbar class="my-md-auto" elevation="0"  >
        <v-toolbar-title class="toolbartitle_50" >
          <h1><v-icon large>mdi-file-cad</v-icon>{{$t('designfile.designfiletypes')}}</h1>
        </v-toolbar-title>
        <v-spacer />
        <v-btn
          :loading="isLoading"
          class="ml-sm-2"
          color="primary"
          v-if="userHasAccess('designfiletype_edit')"
          @click="addHandler"
        >
          {{ $t('global.add')}}
        </v-btn>
      </v-toolbar>

          <DataFilter :handle-filter="onSendFilter" :handle-reset="resetFilter">
            <DesignFileTypeFilterForm
              ref="filterForm"
              :values="filters"
              slot="filter"
            />
          </DataFilter>

          <br />

          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="items"
            :items-per-page.sync="options.itemsPerPage"
            :footer-props="footer"
            :loading="isLoading"
            :loading-text="$t('global.loading')"
            :options.sync="options"
            :server-items-length="totalItems"
            class="elevation-1"
            item-key="@id"
            @update:options="onUpdateOptions"
            @click:row="showHandler"
            @contextmenu:row="showHandlerExt"
          >
            <ActionCell
              slot="item.action"
              slot-scope="props"
              :handle-show="() => showHandler(props.item)"
            ></ActionCell>
          </v-data-table>

      </v-sheet>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ListMixin from '../../mixins/ListMixin';
import ActionCell from '../../components/ActionCell';
import DesignFileTypeFilterForm from '../../components/designfiletype/Filter';
import DataFilter from '../../components/DataFilter';
import AccessMixin from '../../mixins/AccessMixin';

export default {
  name: 'DesignFileTypeList',
  servicePrefix: 'DesignFileType',
  mixins: [ListMixin,AccessMixin],
  components: {
    ActionCell,
    DesignFileTypeFilterForm,
    DataFilter
  },
  data() {
    return {
      headers: [
        { text: this.$t('global.name'), value: 'name' },
        { text: this.$t('global.namefr'), value: 'namefr' },
        {
          text: this.$t('global.actions'),
          value: 'action',
          sortable: false
        }
      ],
      selected: []
    };
  },
  computed: {
    ...mapGetters('designfiletype', {
      items: 'list'
    }),
    ...mapFields('designfiletype', {

      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    })
  },
  methods: {
    ...mapActions('designfiletype', {
      getPage: 'fetchAll',
      deleteItem: 'del'
    })
  }
};
</script>
